import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import "./JsonDialog.css";

const JsonDialog = ({ visible, onHide, jsonForm }) => {
  //eslint-disable-next-line
  const [isFullScreen, setIsFullScreen] = useState(false);

  const handleToggleFullScreen = (selector) => {
    const element = document.querySelector(selector);
    if (!element) {
      console.error(`Element not found for selector: ${selector}`);
      return;
    }

    if (!document.fullscreenElement) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        // Firefox
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        // Chrome, Safari and Opera
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        // IE/Edge
        element.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        // Firefox
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        // Chrome, Safari and Opera
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        // IE/Edge
        document.msExitFullscreen();
      }
    }
  };

  const handleCopyJson = () => {
    const jsonContent = JSON.stringify(jsonForm, null, 2);
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(jsonContent).catch((err) => {
        console.error("Failed to copy JSON: ", err);
      });
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = jsonContent;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
      } catch (err) {
        console.error("Failed to copy JSON: ", err);
      }
      document.body.removeChild(textArea);
    }
  };

  const handleDownloadJson = () => {
    const filename =
      jsonForm && jsonForm.label
        ? `${jsonForm.label}.json`
        : jsonForm && jsonForm.title
          ? `${jsonForm.title}.json`
          : "form.json";

    const blob = new Blob([JSON.stringify(jsonForm, null, 2)], {
      type: "application/json",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  };

  const renderJsonWithLineNumbers = () => {
    // Make a copy of jsonForm and ensure submissionId is included
    const displayJson =
      jsonForm && typeof jsonForm === "object" ? { ...jsonForm } : jsonForm;

    const jsonString = JSON.stringify(displayJson, null, 2);

    return jsonString.split("\n").map((line, index) => {
      const lineWithColoredKeys = line.replace(
        /"(\w+)"(?=\s*:)/g,
        '<span class="json-key">"$1"</span>'
      );

      return (
        <div className="json-line" key={index}>
          <div className="line-number">{index + 1}</div>
          <div
            className="line-data"
            dangerouslySetInnerHTML={{ __html: lineWithColoredKeys }}
          />
        </div>
      );
    });
  };

  return (
    <Dialog
      header="Form JSON"
      visible={visible}
      style={{
        width: window.innerWidth > 768 ? "80vw" : "98vw",
        height: window.innerWidth > 768 ? "80vh" : "95vh",
        maxWidth: window.innerWidth > 768 ? "none" : "98vw",
      }}
      className="json-dialog"
      onHide={onHide}
    >
      <div
        className={`json-viewer ${isFullScreen ? "full-screen" : ""}`}
        style={{
          overflowY: "auto",
          width: "100%",
          height: "95%",
          backgroundColor: "#f0f2f5",
          borderRadius: "8px",
        }}
      >
        <div className="json-view-controls">
          <Button
            icon="pi pi-copy"
            className="json-view-button"
            style={{
              backgroundColor: "#D97A07",
              color: "#fff",
              border: "none",
            }}
            onClick={handleCopyJson}
          />
          <Button
            icon="pi pi-download"
            className="json-view-button"
            style={{
              backgroundColor: "#D97A07",
              color: "#fff",
              border: "none",
            }}
            onClick={handleDownloadJson}
          />
          <Button
            icon="pi pi-window-maximize"
            className="json-view-button"
            style={{
              backgroundColor: "#D97A07",
              color: "#fff",
              border: "none",
            }}
            onClick={() => handleToggleFullScreen(".json-viewer")}
          />
        </div>
        <pre>{renderJsonWithLineNumbers()}</pre>
      </div>
    </Dialog>
  );
};

export default JsonDialog;
